export default {
	labels: {
		subjects: 'Subjects',
	},
	subjects: {
		verify: 'Verify your email - {{brand}}',
		reset: 'Reset your password - {{brand}}',
		welcome: 'Welcome to {{brand}}',
		subscriptionActivated: 'Your subscription is active - {{brand}}',
		emailChangeVerification: 'Confirm your new email - {{brand}}',
		emailChangeNotice: 'Your email was changed - {{brand}}',
	},
	verify: {
		preview: 'Verify your email at {{brand}}',
		greeting: 'Welcome to {{brand}}',
		intro: 'Please confirm your email address to continue.',
		button: 'Verify email',
		codeLabel: 'Verification code',
		codeHelp:
			'If you opened this email on another device, enter this code on the verification screen.',
		footer: 'If you did not create an account, please ignore this email.',
	},
	reset: {
		preview: 'Reset your password at {{brand}}',
		greeting: 'Password reset requested',
		intro:
			'We received a request to reset your password. Click the button below to create a new password.',
		button: 'Reset password',
		footer:
			'If you did not request a password reset, please ignore this email.',
	},
	welcome: {
		preview: 'Welcome to {{brand}}',
		greeting: 'Welcome to {{brand}}',
		intro:
			'Your account is ready. Start your first {{mainEntityLabelLower}} and keep your learning momentum.',
		button: 'Start now',
		footer: 'Need help? Reply to this email and we will help you.',
	},
	subscriptionActivated: {
		preview: 'Your subscription is active at {{brand}}',
		greeting: 'Your subscription is active',
		intro:
			'You now have premium access at {{brand}}. Enjoy full content and premium actions.',
		button: 'Manage subscription',
		footer:
			'You can manage billing details from your account area at any time.',
	},
	emailChangeVerification: {
		preview: 'Confirm your new email at {{brand}}',
		greeting: 'Confirm your new email',
		intro: 'Please confirm this new email address to complete the change.',
		button: 'Confirm new email',
		footer: 'If you did not request this change, please ignore this email.',
	},
	emailChangeNotice: {
		preview: 'Your email was changed at {{brand}}',
		greeting: 'Your email has been changed',
		intro:
			'We are letting you know that your account email address was changed.',
		footer:
			'If you did not request this change, contact support immediately to secure your account.',
	},
}
